"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.News = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const HtmlBlock_1 = require("../HtmlBlock/HtmlBlock");
require("./news.scss");
const News = (props) => {
    const { className, blockTitle, newsTitle, content } = props;
    const classNames = (0, classnames_1.default)('news', className !== null && className !== void 0 ? className : '');
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("h2", { className: 'news__block-title' }, blockTitle),
        !!newsTitle && (react_1.default.createElement("h3", { className: 'news__title' }, newsTitle)),
        react_1.default.createElement(HtmlBlock_1.HtmlBlock, { className: 'news__content', content: content })));
};
exports.News = News;
//# sourceMappingURL=News.js.map